import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal-window',
  templateUrl: './modal-window.component.html',
  styleUrls: ['./modal-window.component.scss']
})


export class ModalWindowComponent implements OnInit {
	@Input() isAdvisor: boolean = false;
	@Input() isFail: boolean;

	msg: string;
	//@Input() title;
	//@Input() modalType: ModalDialogType;
	constructor(public activeModal: NgbActiveModal) { }

	ngOnInit() {
		if (this.isFail) {
			this.msg = `משהו השתבש,<br> אנא נסה שוב מאוחר יותר`
		} else if (this.isAdvisor) {
			this.msg = `הפרטים שמילאת עברו למומחה משכנתאות. <br> ניצור איתך קשר בהקדם לגבי המשך טיפול<br> בבקשת מיחזור משכנתה עבור הלקוחות`
		} else {
			this.msg = `תודה על פנייתך<br>בנקאי יחזור אליך בהקדם`;  
		}
  }

	dismiss() {
		this.activeModal.close({ result: false });
	}	
}


// WEBPACK FOOTER //
// ./src/app/modal-window/modal-window.component.ts